import { Organization as ResponseOrganization } from '~/types/ResponseType'
import { Workspace } from '~/utils/workspaceSelection'

export const isDefaultWorkspace = (workspace: ResponseOrganization | Workspace): boolean => {
  if (!workspace) return false

  return workspace.is_default === true
}
